import React, { useEffect } from "react";
import { IDVCta, IDVErrorText, IdvInfoCard, IDVModalHeading, IDVModalSubHeading, IDVModalWrapper, IDVPrice, IDVPriceText, IDVPriceValue, IDVUnitValue } from "./styles";
import IdvSlider from "@components/IdvContainer/slider";
import { convertToLakhMin } from "@utils/inrFormatter";
import { resolvePath } from "@utils/resolvePath";
import { executeActions, trimLeadingZerosInFloat } from "@utils/index";

export default function IDVModal(props) {
    const {
        heading,
        subHeading,
        infoText,
        ctaText,
        price,
        maxValue = 180000,
        minValue = 1000000,
        handleUpdateModal,
        onclickEffect,
        onModalLoad
    } = props;

    const [priceValue, setPriceValue] = React.useState<number | null>(price);
    const [isError, setIsError] = React.useState(false);

    useEffect(() => {
        if (onModalLoad) {
            executeActions(onModalLoad);
        }
    }, [onModalLoad]);

    const handleChangeSliderValue = (value) => {
        //TODO: find a better way to avoid auto setting of price due to side effects
        if (value === minValue || value === maxValue) return
        setPriceValue(trimLeadingZerosInFloat(value));
        setIsError(false)
    }

    const onSubmit = () => {
        if (handleUpdateModal && handleUpdateModal?.length > 0) {
            handleUpdateModal?.forEach((eachFunc: any) => {
                typeof eachFunc.funCall === "function" &&
                    eachFunc.funCall({
                        ...eachFunc.args,
                        data: {
                            ...eachFunc.args?.data,
                            selected_idv: priceValue,
                        },
                        expected_node: "plan_selection_node"
                    });
            });
        }

        if (onclickEffect instanceof Function) {
            onclickEffect()
        }
    }



    const handleChange = (e) => {
        if (e.target.value === "") {
            setPriceValue(null)
            setIsError(true)
            return
        }
        const value = parseFloat(e.target.value);
        if (value > maxValue || value < minValue) {
            setIsError(true)
        }
        if (!isNaN(value)) {
            setPriceValue(trimLeadingZerosInFloat(value * 100000));
            setIsError(false)
        } else {
            setIsError(true)
        }
    }
    return (
        <IDVModalWrapper>
            <IDVModalHeading>{heading}</IDVModalHeading>
            <IDVModalSubHeading>{subHeading}</IDVModalSubHeading>

            <IdvInfoCard>
                <img alt="idv-info-icon" src={resolvePath("/images/idv_info_icon.svg")} width={"32px"} height={"32px"} />
                <div>
                    <p dangerouslySetInnerHTML={{ __html: infoText }}></p>
                </div>
            </IdvInfoCard>

            <IDVPrice>
                <IDVPriceText>₹</IDVPriceText>
                <IDVPriceValue
                    type="number"
                    step="0.01"
                    value={priceValue ? trimLeadingZerosInFloat(convertToLakhMin(priceValue, false, 2)) : null}
                    onInput={handleChange}
                />
                <IDVUnitValue>{"lakh"}</IDVUnitValue>
            </IDVPrice>

            <IdvSlider
                min={minValue}
                max={maxValue}
                selectedValue={priceValue || 0}
                setSelectedValue={handleChangeSliderValue}
                singleRow={true}
                threshHold={1}
                setSliderInteractionValue={() => { }}
                showRecommendedRange={false}
            />
            {isError ? <IDVErrorText>{`IDV should be between ₹${convertToLakhMin(minValue, false, 1)} lakh and ₹${convertToLakhMin(maxValue, false, 1)} lakh`}</IDVErrorText> : null}

            <IDVCta onClick={onSubmit}>{ctaText}</IDVCta>
        </IDVModalWrapper>
    );
};
